const stats = [
  {
    figure: "10,000+",
    label: "items",
    detail:
      "the scale a single stylist can track before spreadsheets buckle.",
  },
  {
    figure: "73%",
    label: "of wardrobe managers",
    detail:
      "still rely on spreadsheets, group chats, or pen-and-paper logs.",
  },
  {
    figure: "$4.2M",
    label: "average insured value",
    detail:
      "of an active celebrity working wardrobe at any given moment.",
  },
];

export default function Stats() {
  return (
    <section
      data-testid="stats-section"
      aria-labelledby="stats-heading"
      className="py-16 md:py-20 border-y border-border bg-bone"
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-12">
        <h2 id="stats-heading" className="sr-only">
          Industry signals
        </h2>
        <p className="text-[11px] uppercase tracking-[0.28em] text-oxblood font-medium mb-10 md:mb-14">
          — Observed industry figures
        </p>
        <div className="grid md:grid-cols-3 gap-12 md:gap-8">
          {stats.map((s, i) => (
            <div
              key={s.figure}
              data-testid={`stat-${i}`}
              className="border-t border-foreground/15 pt-6"
            >
              <p className="font-display text-5xl md:text-6xl lg:text-7xl leading-none text-foreground">
                {s.figure}
              </p>
              <p className="mt-3 text-sm font-medium tracking-wide uppercase text-foreground/70">
                {s.label}
              </p>
              <p className="mt-3 text-sm text-muted-foreground max-w-xs leading-relaxed">
                {s.detail}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
